<template>
  <div class="search-wrapper--navbar">
    <el-container>
      <el-main class="d--grid">
        <el-menu :default-active="defaultIndex" mode="horizontal">
          <el-menu-item v-if="isCountry" index="trips">
            <nuxt-link
              :to="{
                name: type === 'country' ? 'search-country' : 'search-type',
                params: {
                  type: $t(`router.search_type.type.${type}`),
                  value,
                  tab: $t('router.search_type.tab.trips'),
                  travelTo: $t('router.search_type.travel_to_'),
                },
              }"
            >
              <span v-if="isMobile">{{ $t(`${base}.title.information`) }}</span>
              <span v-else>{{ $t(`${base}.country_information`) }}</span>
            </nuxt-link>
          </el-menu-item>

          <el-menu-item index="tours">
            <nuxt-link
              :to="
                type !== 'country'
                  ? {
                      name: 'search-type',
                      params: {
                        type: $t(`router.search_type.type.${type}`),
                        value,
                        tab: $t('router.search_type.tab.tours'),
                      },
                    }
                  : { name: 'search', query: $route.query }
              "
            >
              <span v-if="isMobile">{{ $t(`${base}.title.experiences`) }}</span>

              <span v-else-if="!!type && !!header.name">
                {{ $t(`${base}.title.${type}`, { name: header.name }) }}
              </span>

              <span v-else>{{ $t(`${base}.meta.title`) }}</span>
            </nuxt-link>
          </el-menu-item>
        </el-menu>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SEARCH_TYPE_ROUTER } from '@/utils/static-router-alias'

export default {
  name: 'LadSearchNavbar',
  props: {
    isCountry: { type: Boolean, required: true },
    isContinent: { type: Boolean, required: true },
    isCity: { type: Boolean, required: true },
  },
  data() {
    return {
      base: 'search',
      openSearch: false,
      defaultIndex: 'tours',
    }
  },
  computed: {
    ...mapState('search', ['header']),
    ...mapGetters('device', ['isMobile']),
    type() {
      const type = this.$route.params.type || this.$route.query.type

      return typeof SEARCH_TYPE_ROUTER.base[type] === 'string'
        ? SEARCH_TYPE_ROUTER.base[type]
        : type
    },
    value() {
      return this.$route.params.value || this.$route.query.value || ''
    },
  },
  watch: {
    '$route.params.tab': {
      immediate: true,
      handler(newValue) {
        if (newValue && ['search-type', 'search'].includes(this.$route.name)) {
          this.defaultIndex =
            typeof SEARCH_TYPE_ROUTER.base[newValue] === 'string'
              ? SEARCH_TYPE_ROUTER.base[newValue]
              : newValue
        }
      },
    },
  },
}
</script>

<style lang="scss">
.search-wrapper--navbar {
  background-color: white;

  .el-main {
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    padding: 0 20px;
    height: 60px;

    /** para poder usar vue-autosuggest */
    overflow: inherit;

    .el-menu-item {
      padding: 0;

      a[href] {
        display: inline-block;
        padding: 0 20px;
      }
    }

    .menu-search {
      .el-menu-item {
        &.menu-item--search-short {
          display: none;
          padding: 0;

          i {
            padding: 0 10px;
            line-height: 58px;
            margin: 0;
            cursor: pointer;
            width: 50px;
            background-color: #f8f8f8;
          }
        }

        &:last-child {
          padding-right: 0;
        }

        &.is-disabled {
          cursor: default;
          opacity: 1;
          border: 0;
        }

        #autosuggest {
          position: relative;
        }
      }
    }
  }

  .el-menu {
    &.el-menu--horizontal {
      border-bottom: transparent;
    }
  }

  .menu-item--search-autocomplete {
    padding: 0;

    .before-input i,
    #autosuggest__input,
    .after-input button {
      height: 36px;
      line-height: 36px;
    }
    .after-input button {
      line-height: 1;
    }
    #autosuggest__input {
      width: 180px;
    }
  }

  .lad-autocomplete-search-wrapper {
    .autosuggest__results {
      margin-top: -11px;
      border-radius: 4px;
    }
  }

  @media screen and (max-width: 1200px) {
    .el-main {
      padding: 0 20px;
    }
  }

  @media screen and (max-width: 750px) {
    .el-main {
      display: block;
      position: relative;
      width: auto;

      .el-menu {
        margin-right: 60px;
        white-space: nowrap;
        box-sizing: content-box;
        display: block;

        .el-menu-item {
          display: inline-block;
          padding: 0 10px;
          float: none;
        }

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      .menu-search {
        position: absolute;
        right: 20px;
        top: 0;

        .el-menu-item {
          &.menu-item--search-autocomplete {
            display: none;
          }

          &.menu-item--search-short {
            display: inline-block;
          }
        }

        &.is-open {
          left: 0;

          .el-menu-item {
            padding: 0 !important;

            &.menu-item--search-autocomplete {
              display: inline-block;
              width: calc(100% - 50px);

              #autosuggest {
                margin: 0 10px 0 20px;

                &__input {
                  width: 100%;
                  border-right: 1px solid #dcdfe6;
                  border-top-right-radius: 4px;
                  border-bottom-right-radius: 4px;
                }
              }

              .after-input {
                display: none !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
